import React, { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';
import ReactGA from 'react-ga';
import { BrowserRouter as Router } from 'react-router-dom';
const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

// Initialize React Ga with your tracking ID
ReactGA.initialize('G-XGHGLW3BJ8');

root.render(
  
    <StrictMode>
      <Router>
           <App /> 
      </Router>
  </StrictMode>
  
  
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
